<dd class="hvac-product-property-list-item-value hvac-p-sm hvac-fw-rg">
    <ng-content></ng-content>
</dd>
